/**
 * Shared chat entrance animations — transform/opacity only so they stay
 * composited (no layout work) on native WebViews, and every one is disabled
 * under prefers-reduced-motion (which iOS propagates into the Capacitor
 * WebView from the system accessibility setting).
 *
 * Plain objects (not SxProps) so call sites can spread them into an sx.
 */

/** Message rows and charts: rise in with a fade. */
export const riseIn = {
  animation: "chatRiseIn 0.3s ease backwards",
  "@keyframes chatRiseIn": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "none" },
  },
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
} as const;

/** Spring for the composer's hero ⇄ conversation shared-element morph
    (framer-motion layoutId). */
export const composerMorph = {
  type: "spring",
  stiffness: 360,
  damping: 32,
} as const;

/** Staggered hero entrance, shared by the chat and research landings so the
    two tabs fly in identically — `backwards` fills the delay window (element
    hidden until its turn) then releases the cascade so hover transforms work. */
export const heroRise = (delay: number) => ({
  animation: `chatHeroRise 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s backwards`,
  "@keyframes chatHeroRise": {
    from: { opacity: 0, transform: "translateY(14px)" },
    to: { opacity: 1, transform: "none" },
  },
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});

/** Streaming prose: newly-arrived blocks fade in (opacity only — a translate
    here would make the surrounding text wiggle as the layout reflows). */
export const streamFadeIn = {
  "& > *, & li, & tbody tr": {
    animation: "chatStreamFadeIn 0.25s ease backwards",
  },
  "@keyframes chatStreamFadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  "@media (prefers-reduced-motion: reduce)": {
    "& > *, & li, & tbody tr": { animation: "none" },
  },
} as const;
